<transition name="tt-o-popover-">
  <div class="tt-o-popover" 
       :class="typeClass"
       @keydown.esc.stop="close"
       :role="role"
       :aria-label="ariaLabel"
       aria-modal="false"
       tabindex="-1"
       aria-live="polite">
    <div class="tt-o-popover__icon">
      <tt-icon :name="iconName" size="sm"></tt-icon>
    </div>
    <div class="tt-o-popover__body">
      <p v-if="message" class="tt-o-popover__text" v-html="message"></p>
      <slot></slot>
    </div>
    <div v-if="showClose" class="tt-o-popover__close">
        <tt-button ref="closeBtn" type="icon" @click.stop="close" class="tt-o-popover__close-btn" :aria-label="closeLabel" :title="closeLabel"><tt-icon name="close" size="xxs"></tt-icon></tt-button>
    </div>
  </div>
</transition>
